import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  AccountInformationApiModel,
  FormsCreatedApiModel,
  SiteSnapshotApiModel,
  UserActivityApiModel,
  UserActivitySearchQuery,
  ProgramsByFormsApiModel
} from '@app/api/api-models/site-settings/dashboard';
import { CustomUtils } from '@app/shared/utils/custom-utils';
import { toQueryParams } from '@app/shared/utils';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class SiteDashboardService {
  public apiUrl = 'site-dashboard';

  constructor(private readonly http: HttpClientService) {}

  public getSiteSnapshot(startDate: Date, endDate: Date): Observable<SiteSnapshotApiModel> {
    const startDateString = CustomUtils.getShortDateString(startDate);
    const endDateString = CustomUtils.getShortDateString(endDate);

    return this.http.get<SiteSnapshotApiModel>(`${this.apiUrl}/site-snapshot`, {
      params: { startDate: startDateString, endDate: endDateString }
    });
  }

  public getAccountInformation(): Observable<AccountInformationApiModel> {
    return this.http.get<AccountInformationApiModel>(`${this.apiUrl}/site-details`);
  }

  public getFormsCreated(startDate: Date, endDate: Date): Observable<FormsCreatedApiModel> {
    const startDateString = CustomUtils.getShortDateString(startDate);
    const endDateString = CustomUtils.getShortDateString(endDate);

    return this.http
      .get<FormsCreatedApiModel>(`${this.apiUrl}/site-forms`, {
        params: { startDate: startDateString, endDate: endDateString }
      })
      .pipe(map((response) => new FormsCreatedApiModel().deserialize(response)));
  }

  public getUserActivity(searchQuery: UserActivitySearchQuery): Observable<UserActivityApiModel> {
    return this.http.get<UserActivityApiModel>(`${this.apiUrl}/users`, { params: toQueryParams(searchQuery) });
  }

  public getSubmitedFormsData(startDate: Date, endDate: Date): Observable<ProgramsByFormsApiModel> {
    const startDateString = CustomUtils.getShortDateString(startDate);
    const endDateString = CustomUtils.getShortDateString(endDate);

    return this.http.get<ProgramsByFormsApiModel>(`${this.apiUrl}/programs-by-forms`, {
      params: { startDate: startDateString, endDate: endDateString }
    });
  }
}
